/**
 * @description 主要Store，待优化，后期尽量不要在该Store进行业务添加
 */

import { ExclamationCircleFilled } from '@ant-design/icons'
import Api from '@api/kong_kong/CardAddApi'
import Api1 from '@api/shou_xie/setMeal'
import shuijingNewApi from '@api/shuijing'
import {
  formatShuijingCatalogList,
  getMerchantInfo,
  jsonToHump,
  jsonToUnderline
} from '@util'
import dayjs from 'dayjs'
import { message, Modal } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import { action, computed, observable, toJS } from 'mobx'
import React from 'react'
import { FIELD_CONFIG } from '../../constants'
import { CASE_CONTENT_IMAGE_LIMIT, UNINO_PHOTO_LIMIT } from '../constants'
import {
  checkImageWidth,
  findCity,
  formatCaseContent,
  formatImageVideo,
  formatMerchaniseItems,
  formatSetMealDetail,
  formatSetMealItems,
  getImgItem,
  isChange
} from '../utils'
import AttractionStore from './attraction'
import CheckImg from './checkImg'

class Store {
  constructor() {
    this.checkImg = new CheckImg()
    this.attractionStore = new AttractionStore()
  }

  @observable tag_list = [] //案例属性
  @observable merchant_info = getMerchantInfo() //商户信息
  @observable case_cate = [] //案例分类
  @observable case_detail = {} //案例详情
  @observable show_form = false //表单可见
  @observable is_add_form = true // true：增加案例表单 false：编辑案例表单
  @observable properties = [] //案例类目
  @observable property_id = ''
  @observable isFromShuijing = false // 是否是从水镜案例同步至平台案例
  @observable topWeddingTags = [] // 高定标签
  @observable selectedTopWeddingTag = []
  @observable selectedTopWeddingTagFrozen = []
  @observable draftId = '' // 草稿id
  @observable isChanged = false

  @observable grayTestFlag = false // 是否是灰度测试城市

  /**
   * @title 获取灰度测试相关城市
   */
  @action
  async getGrayCity() {
    const merchantId = this.merchant_info.id
    const { data, success } = await Api1.getGrayCity({
      merchantId
    })
    if (success) {
      this.grayTestFlag = data?.weddingPlan?.testCity == 1
    }
  }

  /**
   * @title 违规发布限制提示initPage请求
   */
  @action
  async getMercantPublicInfo() {
    const { data, success } = await Api1.getMercantPublicInfo()
    if (success) {
      if (data?.leftChance === 0 && data?.onBlackList) {
        Modal.warning({
          title: `因违规截至 ${dayjs(data?.blackTimeEnd || Date.now()).format(
            'YYYY年MM月DD日 HH:mm:ss'
          )} 前每日限制发布案例${data?.dailyChance}次，今天还可发布${
            data?.leftChance
          }次`
        })
      }
    }
  }

  /**
   * 案例申诉
   */
  @observable auditBoxVisible = false // 案例申诉弹窗visible
  @observable auditMediaList = [] // 案例申诉提交媒体文件数组

  // 案例申诉弹窗开关设置
  @action
  setAuditBoxVisible = visible => {
    this.auditBoxVisible = visible
  }

  // 设置
  @action
  setAuditMediaList = list => {
    this.auditMediaList = list
  }

  @observable complainSuccess = false // 是否提交成功，估计用于防止重复提交
  @action
  submitAuditHanlder = id => {
    // 申诉提交
    const data = this.auditMediaList.map(e => {
      if (e.type.includes('image')) {
        return {
          type: 1,
          photo: {
            path: e.url,
            width: e.width,
            height: e.height
          }
        }
      } else {
        return {
          type: 2,
          video: {
            path: e.url,
            width: e.width,
            height: e.height,
            cover_path: e.thumbUrl
          }
        }
      }
    })

    if (data.length === 0) {
      message.error('请上传凭证后发起申诉')
      return
    }

    Api1.lunchComplaint({
      caseId: id,
      materials: {
        caseAppeal: data
      }
    }).then(({ success }) => {
      if (success) {
        this.auditBoxVisible = false
        this.complainSuccess = true
        message.success('申诉已提交，等待审核结果')
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      } else {
        message.error('提交失败，请重试')
      }
    })
  }

  // 初始值，为了防止对象取值报错
  @observable
  form_init = {
    _platform: '2',
    title: '',
    _store_title: '',
    cover_path: {
      cover_img: {},
      up_cover_img: {}
    },
    case_content: [],
    _merchant_category_id: '',
    _mirror_category_id: [],
    _show_in_shuijing: '0',
    _meal_type: '1',
    is_show_case: false,
    is_show_kezhao: false,
    work_ids: [],
    cover_video: null,
    caseReference: '',
    person_id: '',
    report: false,
    certified: null
  }

  // 计算图片张数
  @computed
  get imgNum() {
    return this.tempCaseContent.filter(el => el.type == 'img').length
  }

  // 技术视频个数
  @computed
  get videoNum() {
    return this.tempCaseContent.filter(el => el.type == 'video').length
  }

  //
  @computed
  get restCaseImageNum() {
    return CASE_CONTENT_IMAGE_LIMIT - this.imgListPreview.length - this.imgNum
  }

  // 通用修改store方法
  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  // 设置property_id，加盟店会涉及到多个类目因此会有此变量
  @action
  setPropertyId = id => {
    this.property_id = id
    if (id == '') {
      this.tag_list = []
      return
    }
    this.getMealMarks()
  }

  /**
   * @title 获取案例标签全部数据
   */
  @action
  getMealMarks = async () => {
    const { data, success } = await Api.getMealMarks({
      property_id: this.property_id,
      commodity_type: 1
    })
    if (success) {
      this.tag_list = data
    }
  }

  // 修改案例属性状态 根据接口对每个标签选择做限制
  @action
  changeTagValue = (i, j, flag, item) => {
    const tempList = [...this.tag_list]
    const maxCount = item.quantity_range[1]

    if (!flag) {
      tempList[i].children[j].isActive = false
      this.tag_list = toJS(tempList)
      return
    }

    // 已active的tag数量
    const activeList = tempList[i].children.filter(e => e.isActive)
    if (activeList.length >= maxCount) {
      message.error(`该属性最多选择${maxCount}个标签`)
    } else {
      tempList[i].children[j].isActive = true
    }

    this.tag_list = JSON.parse(JSON.stringify(tempList))
  }

  /**
   * @title 获取案例分类列表
   */
  @action
  initLabelList = async () => {
    const { data, success } = await Api.getCaseCate()
    if (success) {
      this.case_cate = data
    }
  }
  /**
   * @title 通过接口获取高定标签 若merchant_info.top_wedding 为 1 || true 则显示选择
   */
  @action
  getTopWeddingTag = async () => {
    const { data, success } = await Api.getTopWeddingTag({
      property_id: this.merchant_info.property_id
    })
    if (success) {
      this.topWeddingTags = data
    }
  }

  // 变更高定标签change
  @action
  changeTopWeddingTags = label_id => () => {
    this.selectedTopWeddingTag = this.selectedTopWeddingTag.some(
      el => el == label_id
    )
      ? []
      : [label_id]
  }

  // 自定义添加案例分类
  @action
  submitCasseCate = async value => {
    let { success } = await Api.addCaseCate(value)
    if (success) {
      message.success('分类新建成功')
      this.initLabelList()
    }
  }

  @observable forceLeave = false
  @observable submitting = false // 和 show_form 相同作用，都是为了控制整个页面是否处于loading状态，可合并为一个值进行控制
  // 提交表单
  @action
  submitForm = async (value, type, _isChanged) => {
    // 校验图片 是否非rgb的图片
    if (!(await this.checkImg.beforeAction({ types: [2, 3] }))) {
      this.submitting = false
      return
    }
    // 头部视频 处理视频提交数据
    const merchandise_items = formatMerchaniseItems(value)
    // 案例详细信息 内容 提交时数据处理 ! 别看方法命名
    const set_meal_detail = formatSetMealDetail(value)
    // 案例封面横图
    const coverImg = value?.cover_path?.cover_img?.href
    // 案例封面方图 或 竖图
    const upCoverImg = value?.cover_path?.up_cover_img?.href
    // _setMeal参数 包括： 案例标题、案例封面（横图+方图）
    const set_meal = {
      commodity_type: '1', //0套餐 1案列
      cover_path: coverImg, // 封面 ？ 为什么和case_head_img 相同
      title: value.title, // 案例标题
      case_head_img: coverImg || '', // 封面
      vertical_image: upCoverImg || '' // 方图
    }
    // 案例信息 包括: 婚礼日期、婚礼地点、参考价格
    const set_meal_items = formatSetMealItems(
      value,
      this.property_id,
      this.attractionStore.cityName,
      this.attractionStore.spotName,
      this.attractionStore.spotId
    )

    /**
     * 实例认证数据处理 start
     */
    // 限定商家类目 婚策 灰度测试 propertyId = 2时，举证提交图片数据格式处理
    const validPhoto = formatImageVideo(value.verify_others)
    // 处理原片/视频提交数据格式
    const originalResource = formatImageVideo(value.verify_origin)
    if (validPhoto.length > 0 && originalResource.length == 0) {
      message.warning('请上传婚礼现场原片或视频')
      this.submitting = false
      return false
    }
    const proofCase = {
      isChanged: true,
      materials: {
        wedding: originalResource,
        other: validPhoto
      }
    }
    /**
     * 实例认证数据处理 end
     */

    /**
     * 必选标签验证 start
     */
    const tag_list = []
    const tag_list_parent_id = {}
    const require_tag_id = this.tag_list
      .filter(tag => tag.required == 1)
      .map(tag => String(tag.id))

    for (let i = 0; i < this.tag_list.length; i++) {
      for (let j = 0; j < this.tag_list[i].children.length; j++) {
        if (this.tag_list[i].children[j].isActive) {
          tag_list_parent_id[this.tag_list[i].id] = this.tag_list[i].id
          tag_list.push(this.tag_list[i].children[j].mark_id)
        }
      }
    }

    const selected_items_parent_id = Object.keys(tag_list_parent_id).map(e =>
      String(e)
    )
    const isMatchAll = require_tag_id.every(id =>
      selected_items_parent_id.includes(id)
    )
    if (!isMatchAll && !(this.draftId || type == 'draft')) {
      message.warning('请选择必选案例标签')
      this.submitting = false
      return false
    }
    /**
     * 必选标签验证 end
     */

    const params = {
      property_id: value.property_id ?? this.merchant_info.property_id,
      merchandise_items, // 头部视频
      set_meal_detail, // 案例正文
      set_meal,
      set_meal_items,
      merchant_category_id: value?._merchant_category_id, // 案例分类
      mirror_category_id: value?._mirror_category_id?.join(','), // 水镜分类
      meal_type: value?._meal_type,
      work_ids: this.tempIds?.join(',') ?? null,
      person_id: value?.person_id || '',
      scenic_spot_single: {
        id: this.attractionStore.spotId,
        name:
          this.attractionStore.spotId + '' ? this.attractionStore.spotName : ''
      },
      scenic_spot_cid: this.attractionStore.scenic_spot_cid,
      proof_case: proofCase,
      tag_list: tag_list?.join(',') ?? undefined,
      platform: this.isFromShuijing || value?._show_in_shuijing === '1' ? 3 : 1,
      top_label: this.merchant_info?.top_wedding && this.selectedTopWeddingTag
    }

    // 大小写转驼峰
    jsonToHump(params)

    // 保存为草稿
    if (type == 'draft') {
      // 发布草稿的时候带上案例封面的x,y,w,h这四个裁剪值
      // 并且图片使用裁剪的格式
      params.coverPathXywh = value.cover_path ?? value.coverPathXywh
      params.setMeal.originalCoverPath =
        value?.cover_path?.cover_img?.href ?? ''
      params.setMeal.caseHeadImg = params.setMeal.originalCoverPath
      params.setMeal.verticalImage = value?.cover_path?.up_cover_img?.href ?? ''
      await this.saveDraft(params)
      return
    }

    // 如果是通过草稿发布，需要加上id和type
    if (this.draftId) {
      params.draft_id = this.draftId
      params.draft_type = 'case'
    }

    // 如果是新增案例
    if (this.is_add_form) {
      // 案例的来源，案例生成后就不可改变。1：水镜案例，0：平台案例
      params.source = this.isFromShuijing ? 1 : 0
      const { success, data } = await Api.addCase(params, '')
      this.forceLeave = true
      this.submitting = false
      if (success) {
        if (value._show_in_shuijing === '1') {
          // 选择展示到水镜
          this.handleCaseToShuijing(data.id, value._mirror_category_id)
        }
        return data
      }
    } else {
      // 编辑案例
      params['id'] = this.case_detail.id
      if (
        !isChange(
          tag_list,
          this.case_detail,
          this.isChanged,
          this.selectedTopWeddingTag,
          this.selectedTopWeddingTagFrozen
        ) &&
        !this.isFromShuijing
      ) {
        message.warning('未修改任何信息，无需提交审核')
        this.submitting = false
        return false
      }

      const { success, data } = await Api.editCase(params, '')
      this.submitting = false
      if (success) {
        this.forceLeave = true
        return data
      }
    }
  }

  @observable needReload = true
  saveDraft = async value => {
    if (this.draftId) {
      value.id = this.draftId
    }
    const { success, data } = await Api.saveDraft(value)
    this.forceLeave = true
    if (success) {
      message.success('提交成功')
      if (this.needReload) {
        // 刷新页面
        window.location.href = `#/localMerchant/case/add?propertyId=${
          this.property_id
        }&draftId=${data}`
        window.location.reload()
      }
    }
    this.submitting = false
  }

  /**
   * @title 获取案例详情
   */
  @action
  getCaseDetail = async id => {
    const { data, success } = await Api.getCase({ id })
    if (success) {
      // 转下划线
      jsonToUnderline(data)
      this.case_detail = data
    }
  }

  /**
   * @title 获取案例草稿详情
   */
  @action
  getDraftDetail = async id => {
    const { data, success } = await Api.getDraftDetail({ id })
    if (success) {
      // 转下划线
      jsonToUnderline(data)
      this.case_detail = data.content
    }
  }

  /**
   * @title 获取水镜案例详情
   */
  @action
  getShuijingCaseDetail = async id => {
    const {
      data,
      success
    } = await shuijingNewApi.getShuijingCaseWithPlatformlike({ id })
    this.show_form = true
    if (success) {
      let d = {
        ...this.form_init,
        title: data.title,
        cover_path: {
          cover_img: {
            href: data.cover_path
          },
          up_cover_img: {
            href: data.vertical_image
          }
        },
        case_content: formatCaseContent(data.set_meal_detail).slice(0, 50),
        cover_video: data.merchandise_items[0]
          ? {
              link: data.merchandise_items[0].media_path,
              type: 'video',
              persistent_id: data.merchandise_items[0].persistent_id,
              cover_path: data.merchandise_items[0].cover_path,
              width: data.merchandise_items[0].width,
              height: data.merchandise_items[0].height
            }
          : null
      }
      jsonToUnderline(d)
      this.form_init = d
      this.tempCaseContent = formatCaseContent(data.set_meal_detail).slice(
        0,
        50
      )
    }
  }
  // 将婚礼纪案例同步至水镜门店案例
  @action
  handleCaseToShuijing = async (id, positions) => {
    const query = {
      setMealIds: String(id),
      moduleIds: positions.join(',')
    }
    await shuijingNewApi.importPlatformCaseToShuijing(query)
  }
  /**
   * @title 获取商家类目 仅限于加盟店使用
   */
  @action
  getCaseProperties = async () => {
    const { data, success } = await Api.getCaseProperties()
    if (success) {
      this.properties = data.list
    }
  }
  @observable shuijingCategoryList = [] // 案例分类级联列表
  /**
   * @title 获取水镜分类
   */
  @action
  getShuijingCategory = async () => {
    const {
      data,
      success
    } = await shuijingNewApi.getMirrorCategoryCascaderListNew({
      parentId: 0,
      contentType: 0
    })
    if (success) {
      this.shuijingCategoryList = formatShuijingCatalogList(data || [])
    }
  }

  // 初始化新增表单
  @action
  initAddForm = () => {
    let show_case = false
    let show_kezhao = false
    if (!this.is_add_form) {
      show_case =
        this.case_detail?.set_meal_extend?.is_show_case == '1' ? true : false
      show_kezhao =
        this.case_detail?.set_meal_extend?.is_show_kezhao == '1' ? true : false
    }
    this.form_init = Object.assign({}, this.form_init, {
      is_show_case: show_case,
      is_show_kezhao: show_kezhao
    })
    this.show_form = true
    setTimeout(() => {
      this.firstAutoRun = false
    }, 1000)
  }

  // 初始化案例信息
  initCaseInfo = () => {
    // 案例信息
    let case_info = {}
    if (
      this.case_detail &&
      this.case_detail.work_items &&
      this.property_id == 2 //婚礼策划
    ) {
      const wedding_date = this.case_detail.work_items.find(
        i => i.name == '婚礼日期'
      )
      case_info['wedding_date'] =
        wedding_date && wedding_date.describe
          ? dayjs(wedding_date.describe)
          : null
      const hotel = this.case_detail.work_items.find(i => i.name == '婚礼地点')
      const caseReference = this.case_detail.work_items.filter(
        i => i.name == '参考价格'
      )[0]?.describe
      case_info['hotel_name'] = hotel ? hotel.describe : ''
      case_info['caseReference'] = caseReference || ''
      case_info['hotel_id'] = hotel ? hotel.merchant_id : ''
      // TODO 婚礼策划
    } else if (this.case_detail && this.case_detail.work_items.length) {
      if (this.property_id == 6) {
        //婚纱摄影
        const city =
          this.case_detail.work_items.find(i => i.name == '拍摄城市') || {}
        this.attractionStore.spotId = this.case_detail.scenic_spot_single.id
        if (!isEmpty(city) && city.describe) {
          let cityInfo = findCity(city.describe, this.attractionStore.allCity)
          this.attractionStore.getScenicSpotByCityCode(cityInfo.citycode)
          this.attractionStore.cityName = [cityInfo.provice.key, city.describe]
          this.attractionStore.scenic_spot_cid = cityInfo.citycode
        }
        this.attractionStore.spotName = this.case_detail.scenic_spot_single.name
      }

      //兼容老数据
      const oldData =
        this.case_detail.work_items.find(i => i.name == '拍摄地/景点') || {}

      if (!isEmpty(oldData)) {
        this.attractionStore.spotId = 0
        this.attractionStore.spotName = oldData.describe
      }

      const fields = FIELD_CONFIG[this.property_id]
      if (fields) {
        fields.forEach(item => {
          const work_item = this.case_detail.work_items.find(
            i => i.name == item.title
          )
          if (item.type == 'text') {
            case_info[item.title] = work_item ? work_item.describe : ''
          } else if (item.type == 'date') {
            case_info[item.title] = work_item?.describe
              ? dayjs(work_item.describe)
              : null
          }
        })
      }
    }

    return case_info
  }

  /**
   * @title 若是编辑或草稿情况下，获取接口数据后，将获取到的数据回填表单
   */
  @action
  initUpdateForm = () => {
    this.show_form = true
    const tagIds = (this.case_detail.tags || []).map(item => item.mark_id)
    this.initTagList(tagIds)
    const case_info = this.initCaseInfo()
    const merchant_material = this.case_detail?.proof_case?.materials || {
      other: [],
      wedding: []
    }

    const form_default = {
      _platform: this.case_detail.platform
        ? this.case_detail.platform + ''
        : '2',
      title: this.case_detail.title,
      _store_title: this.case_detail.set_meal_extend
        ? this.case_detail.set_meal_extend.shop_title
        : '',
      cover_path: {
        cover_img: {
          href:
            this.case_detail.cover_path || this.case_detail.case_head_img || ''
        },
        up_cover_img: {
          href: this.case_detail.vertical_image
        }
      },
      _merchant_category_id: this.case_detail.merchant_category
        ? this.case_detail.merchant_category.id && !this.isFromShuijing
          ? this.case_detail.merchant_category.id
          : ''
        : '',
      _mirror_category_id: !isEmpty(this.case_detail.mirror_category)
        ? this.case_detail.mirror_category.map(item => String(item.id))
        : [],
      _show_in_shuijing: !isEmpty(this.case_detail.mirror_category) ? '1' : '0',
      property_id: this.case_detail.property_id,
      is_show_case:
        this.case_detail.set_meal_extend &&
        this.case_detail.set_meal_extend.is_show_case == '1'
          ? true
          : false,
      is_show_kezhao:
        this.case_detail.set_meal_extend &&
        this.case_detail.set_meal_extend.is_show_kezhao == '1'
          ? true
          : false,
      _meal_type: this.case_detail.meal_type + '',
      person_id:
        this.case_detail.set_meal_extend &&
        this.case_detail.set_meal_extend.person_id
          ? this.case_detail.set_meal_extend.person_id
          : this.case_detail.person_id || undefined,
      verify_origin:
        merchant_material?.wedding?.map(e => {
          if (e.type == 2) {
            return {
              url: e?.video?.path,
              width: e?.video?.width,
              height: e?.video?.height,
              type: 'video'
            }
          } else {
            return {
              url: e?.photo?.path,
              width: e?.photo?.width,
              height: e?.photo?.height,
              type: 'image'
            }
          }
        }) || [],
      verify_others:
        merchant_material?.other?.map(e => ({
          url: e?.photo?.path,
          width: e?.photo?.width,
          height: e?.photo?.height,
          type: 'image'
        })) || [],
      report: this.case_detail?.merchant_proof?.report, // 是否被举报
      certified: this.case_detail?.merchant_proof?.certified // 案例认证
    }

    // 用于客照
    const meal_relation = this.case_detail.meal_relation
      ? this.case_detail.meal_relation
      : []
    this.tempIds = []
    meal_relation.forEach(id => {
      const kezhao = this.kezhaoList.find(item => item.id == id)
      if (kezhao) {
        this.tempIds.push(id)
      }
    })
    this.isShowkeZhaoItem = !!this.kezhaoLen
    this.tempCaseContent = formatCaseContent(
      this.case_detail.set_meal_detail
    ).slice(0, 50)
    let head_img_new = !isEmpty(this.case_detail.head_img_new)
      ? toJS(this.case_detail.head_img_new)
      : null
    head_img_new =
      Array.isArray(head_img_new) && head_img_new.length
        ? head_img_new[0]
        : head_img_new
    const cover_video = head_img_new
      ? {
          link: head_img_new.media_path,
          type: 'video',
          persistent_id: head_img_new.persistent_id,
          cover_path: head_img_new.cover_path,
          width: head_img_new.width,
          height: head_img_new.height
        }
      : null
    this.form_init = Object.assign({}, case_info, form_default, {
      cover_video: cover_video
    })

    this.selectedTopWeddingTag = this.case_detail.top_label
    this.selectedTopWeddingTagFrozen = this.case_detail.top_label
    setTimeout(() => {
      this.firstAutoRun = false
    }, 1000)
  }

  @observable firstAutoRun = true
  /**
   * @title 初始化页面数据，接口请求
   */
  @action
  initPage = async (
    id,
    propertyId,
    is_show_kezhao,
    isFromShuijing,
    draftId = ''
  ) => {
    this.property_id = propertyId ? propertyId : this.merchant_info.property_id
    this.isFromShuijing = isFromShuijing

    await Promise.all([
      this.attractionStore.getAllCity(),
      this.getMealMarks(),
      this.getKeZhaoList(),
      this.initLabelList(),
      this.getCaseProperties(),
      this.getShuijingCategory(),
      this.getGrayCity(),
      this.getMercantPublicInfo()
    ])

    // 若为高定商家
    if (!!this.merchant_info.top_wedding) {
      this.getTopWeddingTag()
    }

    // 草稿箱进入
    if (draftId) {
      await this.getDraftDetail(draftId)
      // 草稿模式下也属于新增案例类型
      this.is_add_form = true
      this.draftId = draftId
      this.initUpdateForm()
      return
    }
    // TODO 设置loading
    // 非草稿箱的编辑下进入
    if (id) {
      if (isFromShuijing) {
        // 如果是来自水镜的案例，获取详情后作为新增类型来操作
        await this.getShuijingCaseDetail(id)
        this.is_add_form = true
        setTimeout(() => {
          this.firstAutoRun = false
        }, 1000)
      } else {
        await this.getCaseDetail(id)
        this.is_add_form = false
        this.initUpdateForm()
      }
    } else {
      // 新增案例
      this.initAddForm(is_show_kezhao)
    }
  }

  /**
   * @title 初始化案例标签并回填选中标签
   */
  initTagList = tagIds => {
    if (!tagIds || tagIds.length == 0) {
      return
    }

    const tempTags = [...this.tag_list]

    for (let i = 0; i < tempTags.length; i++) {
      if (!tempTags[i].children) {
        continue
      }
      for (let j = 0; j < tempTags[i].children.length; j++) {
        if (tagIds.indexOf(tempTags[i].children[j].mark_id) > -1) {
          tempTags[i].children[j].isActive = true
        }
      }
    }

    this.tag_list = [...tempTags]
  }

  // 案例详细信息客照部分
  @observable kezhaoList = []
  @observable isShowkeZhaoItem = false
  @observable isShowKeZhao = false
  @observable hideOhterKeZhao = false
  @observable tempIds = []
  @computed
  get kezhaoLen() {
    return this.tempIds.length
  }

  /**
   * @title 获取客照适用于 婚纱摄影 propertyId = 6
   */
  @action
  getKeZhaoList = async (title = '') => {
    const params = {
      page: 1,
      per_page: 9999,
      title
    }
    const { data } = await Api.getKeZhaos(params)

    this.kezhaoList = data.list || []
  }

  /**
   * @title 查看客照 适用于 propertyId = 6 婚纱摄影
   */
  @action
  showKeZhao = () => {
    this.isChanged = true
    this.caseContentTitleStatus = false
    this.isShowkeZhaoItem = true
    this.isShowKeZhao = true
    this.tempCaseContent = this.tempCaseContent.map(item => ({
      ...item,
      active: false
    }))
    document.querySelector('#case-edit').style.marginTop = 0
    document.querySelector('#content_info').scrollTop = 0
  }

  /**
   * @title 隐藏客照
   */
  @action
  hideKeZhao = () => {
    this.isShowKeZhao = false
  }

  /**
   * @title 客照点击选中
   */
  @action
  onTempClick = temp => {
    const index = this.tempIds.findIndex(item => item == temp.id)
    if (index > -1) {
      this.tempIds.splice(index, 1)
      return
    }
    if (this.kezhaoLen >= UNINO_PHOTO_LIMIT) {
      message.error(`您可以最多关联${UNINO_PHOTO_LIMIT}个客照`)
    } else {
      this.tempIds.push(temp.id)
    }
  }

  @observable hotels = []
  /**
   * @title 搜索酒店名称，用于婚礼地点搜索
   */
  @action
  onSearchHotel = async value => {
    if (!value) {
      this.hotels = []
      return
    }
    const { success, data } = await Api.getHotels({ search: value })
    if (success) {
      this.hotels = data.list || []
    }
  }

  // 案例详细信息业务部分
  // 0521案例正文修改
  @observable preLength = 0
  @observable tempCaseContent = []
  @observable imgListPreview = [] // 图片拖拽区域
  @observable caseContentModalStatus = false
  @observable caseContentTitleStatus = false
  @observable imgModalStatus = false
  @action
  initCaseContentModal = (list = []) => () => {
    this.tempCaseContent = list.map(el => ({ ...el, active: false }))
    this.caseContentModalStatus = true
  }
  @action
  closeCaseContentModal = () => {
    this.caseContentModalStatus = false
    this.preLength = 0
  }
  @action
  submitCaseContentModal = () => {
    this.caseContentModalStatus = false
  }
  @action
  changeActiveCase = (index, cb) => {
    this.caseContentTitleStatus = false
    this.unoinPhotoVisible = false
    this.tempCaseContent = this.tempCaseContent.map((item, i) => ({
      ...item,
      active: i == index
    }))
    this.isShowKeZhao = false
    cb && cb()
    this.caseContentTitleStatus = this.tempCaseContent[index].type == 'title'
  }
  @action
  deleteCaseContent = index => () => {
    this.tempCaseContent.splice(index, 1)
    this.caseContentTitleStatus = false
    this.unoinPhotoVisible = false
  }
  @action
  moveUpCaseContent = index => () => {
    const theObjectBeingMoved = this.tempCaseContent[index]
    this.tempCaseContent.splice(index, 1)
    this.tempCaseContent.splice(index - 1, 0, theObjectBeingMoved)
  }
  moveDownCaseContent = index => () => {
    const theObjectBeingMoved = this.tempCaseContent[index]
    this.tempCaseContent.splice(index, 1)
    this.tempCaseContent.splice(index + 1, 0, theObjectBeingMoved)
  }
  @action
  copyCaseContent = (index, cb) => () => {
    const theObjectBeingMoved = this.tempCaseContent[index]
    this.tempCaseContent.splice(index + 1, 0, theObjectBeingMoved)
    this.changeActiveCase(index + 1)
    cb && cb()
  }
  @action
  replaceCaseContentImage = index => (file, link, info) => {
    const editImage =
      this.tempCaseContent[index] && this.tempCaseContent[index].link
    editImage &&
      this.checkImg.editImage &&
      this.checkImg.editImage(3, link, editImage)
    this.tempCaseContent.splice(index, 1, {
      ...getImgItem(link, info),
      active: true
    })
  }
  @action
  showTitleEditor = index => () => {
    this.tempCaseContent = this.tempCaseContent.map((el, i) => ({
      ...el,
      active: i == index
    }))
  }
  @action
  addCaseContentTitle = (index, cb) => () => {
    const insertIndex =
      typeof index !== 'undefined' ? index : this.tempCaseContent.length - 1

    this.tempCaseContent.splice(insertIndex + 1, 0, {
      type: 'title',
      title: '',
      text: '',
      showTips: true
    })

    this.changeActiveCase(insertIndex + 1, cb)
  }
  @action
  saveCaseTitle = ({ title, text }) => {
    this.tempCaseContent = this.tempCaseContent.map((item, i) => {
      const { active, showTips, ...rest } = item
      return active
        ? { ...rest, title, text, active: false }
        : showTips
          ? { ...rest, showTips, active: false }
          : { ...rest, active: false }
    })
    this.caseContentTitleStatus = false
  }

  @action
  saveCaseValue = (type, value) => {
    const idx = this.tempCaseContent.findIndex(item => item.active)
    this.tempCaseContent[idx] = {
      ...this.tempCaseContent[idx],
      [type]: value
    }
  }
  @action
  addCaseContentImg = () => {
    this.imgModalStatus = true
  }
  @action
  addCaseContentVideo = video => {
    this.tempCaseContent.push({ ...video, active: false })
  }
  replaceCaseContentVideo = index => video => {
    this.tempCaseContent.splice(index, 1, { ...video, active: true })
  }
  @action
  getUploadPictureLength = length => {
    this.preLength = length
  }
  @action
  uploadPicture = (file, link, info) => {
    if (this.restCaseImageNum > 0) {
      if (checkImageWidth(info)) {
        this.imgListPreview.push(getImgItem(link, info))
        this.checkImg.checkCMYK(3, link)
        if (!this.imgModalStatus) {
          this.imgModalStatus = true
        }
      } else {
        message.warning('图片尺寸高度需在8192像素以下')
        this.preLength -= 1
      }
    } else {
      message.warning('最多上传50张图片')
      this.preLength -= 1
    }
  }
  @action
  clearPreview = () => {
    this.imgModalStatus = false
    this.imgListPreview = []
  }
  @action
  savePreview = cb => {
    this.tempCaseContent = [...this.tempCaseContent, ...this.imgListPreview]
    this.clearPreview()
    cb && cb()
  }
  @action
  deletePreviewPicture = index => () => {
    this.imgListPreview.splice(index, 1)
    this.preLength -= 1
  }
  @action
  sortPicture = sortPreviewList => {
    this.imgListPreview = sortPreviewList
  }
  @action
  addCaseContentImageTitle = index => () => {
    this.addCaseContentTitle(index)()
  }

  @action
  deleteCase = async (id, isDraft) => {
    this.forceLeave = true
    let res
    if (isDraft) {
      res = await Api.delDraft({ id })
    } else {
      res = await Api.deleteSetMeal({ id })
    }

    const { success, msg } = res
    if (success) {
      window.location.hash = isDraft
        ? '#/localMerchant/case/draftList'
        : '#/localMerchant/case'
    } else {
      Modal.warning({
        title: msg,
        icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
      })
    }
  }

  /**
   * @title 检查文字是否存在敏感词
   */
  @action
  checkWord = async (content, type = 2) => {
    if (!content || !content.trim()) {
      return { code: 0 }
    }
    const { data } = await Api.checkWord({ content, type })
    return data
  }

  @action
  checkActiveTitle = async () => {
    const idx = this.tempCaseContent.findIndex(item => item.active)
    if (idx < 0) {
      return false
    } else {
      const obj = this.tempCaseContent[idx]
      const data = await this.checkWord(obj.title + obj.text)
      const { code, keywords } = data
      if (code == 1) {
        message.warning(`存在敏感词 ${keywords.join(',')}`)
        return true
      }
    }
  }
}

export default Store
